var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStartcomponent = function SvgStartcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.5 31-1.129.988 1.129 1.29 1.129-1.29L12.5 31Zm0 0 1.129.987.003-.003.006-.007.023-.026.085-.1a60.82 60.82 0 0 0 1.417-1.734 66.476 66.476 0 0 0 3.342-4.64c1.215-1.857 2.45-3.98 3.387-6.135.927-2.136 1.608-4.41 1.608-6.542 0-6.202-4.876-11.3-11-11.3s-11 5.098-11 11.3c0 2.131.68 4.406 1.608 6.542.936 2.155 2.172 4.278 3.387 6.136a66.473 66.473 0 0 0 4.759 6.374l.085.1.023.025.006.007.002.003h.001L12.5 31Zm0-20.2c-1 0-1.893.852-1.893 2 0 1.148.892 2 1.893 2 1 0 1.893-.852 1.893-2 0-1.148-.892-2-1.893-2Z",
    fill: "#70D6BA",
    stroke: "#E2F7F1",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 2.5,
    fill: "#E2F7F1"
  })));
};
export default SvgStartcomponent;